import '../assets/styles/index.css';

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          This is home page.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default Home;
